import { render, staticRenderFns } from "./DetailProduct.vue?vue&type=template&id=1a5b404b&"
import script from "./DetailProduct.vue?vue&type=script&lang=js&"
export * from "./DetailProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports